// This icon file is generated automatically.
var CloudDownloadFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16 7.27V8.5a4 4 0 110 8H4a4 4 0 01-.8-7.92A2.99 2.99 0 016 4.5c.55 0 1.07.14 1.51.4A4.5 4.5 0 0116 7.27zm-4.55 4.15V6.5h-2v4.92H7l3.45 4.08 3.47-4.08h-2.47z", "fill-rule": "evenodd" } }] }, "name": "cloud-download", "theme": "filled" };
export default CloudDownloadFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CloudDownloadFilled.js
// module id = 2242
// module chunks = 0